import { useRef, useEffect } from 'react';
import { registerGuard } from '../unsavedGuard';
// isDirty should be a function that returns a boolean when called.
// showPrompt: optional async function that returns boolean (true = allow navigation)
export default function useUnsavedChangesWarning(isDirty, message = 'You have unsaved changes. Are you sure you want to leave without saving?', showPrompt) {
    const messageRef = useRef(message);



    // Block browser/tab close
    useEffect(() => {
        if (!isDirty) return;
        const beforeUnload = (e) => {
            if (!isDirty()) return;
            e.preventDefault();
            e.returnValue = messageRef.current;
            return messageRef.current;
        };
        window.addEventListener('beforeunload', beforeUnload);
        return () => {
            window.removeEventListener('beforeunload', beforeUnload);
        };
    }, [isDirty]);

    // Register with global unsavedGuard so top-level interceptor can consult this hook
    useEffect(() => {
        if (!isDirty) return;
        const promptFn = showPrompt && typeof showPrompt === 'function'
            ? showPrompt
            : () => Promise.resolve(window.confirm(messageRef.current));
        const unregister = registerGuard({ isDirty, showPrompt: promptFn });
        return () => {
            try { unregister(); } catch (e) { /* ignore */ }
        };
    }, [isDirty, showPrompt]);


}
